import React, { useState } from 'react'
import { LocationCardCN } from 'components/Card'
import { CARD_GRID_CLASS } from 'components/Card/cardGrid'
import LocationActionSheet from './LocationActionSheet'

interface LocationsCardsProps {
	locations: any[]
	userId: string
	linkState?: any
}

const LocationsCards = ({ locations, userId, linkState }: LocationsCardsProps) => {
	const [sheetOpen, setSheetOpen] = useState(false)
	const [selectedLocation, setSelectedLocation] = useState<any>(null)

	const handleThreeDotClick = (location: any) => {
		setSelectedLocation(location)
		setSheetOpen(true)
	}

	return (
		<div>
			<div className={CARD_GRID_CLASS}>
				{locations.map((location: any, index: number) => (
					<div key={location._id || index}>
						<LocationCardCN
							image={location.image}
							isCenter={location.assetType !== 'location'}
							name={location.assetName}
							address1={location.address}
							address2={`${location.city}, ${location.stateProvince}`}
							linkUrl={`/locations/${location._id}`}
							linkState={linkState}
							projectCount={location.projectCount || 0}
							onThreeDotClick={() => handleThreeDotClick(location)}
							isOwner={location.owner._id === userId}
							ownerImage={location.owner.image}
							ownerName={location.owner.name}
							ownerEmail={location.owner.email}
							ownerCompany={location.owner.company}
						/>
					</div>
				))}
			</div>

			<LocationActionSheet
				location={selectedLocation}
				open={sheetOpen}
				onClose={() => setSheetOpen(false)}
			/>
		</div>
	)
}

export default LocationsCards
